import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PermissionService } from 'app/security/permission';
import { ROLE } from '../roles.const';
import { UserComponent } from '../user.component';
import { UserFormComponent } from '../user-form/user-form.component';
import { UserImportComponent } from 'app/import/user-import/user-import.component';
import { ParticipantListComponent } from './participant-list/participant-list.component';
import { UserResolve } from '../user.resolve';

const routes: Routes = [
  {
    path: 'participant',
    component: UserComponent,
    data: {
      breadcrumb: 'participant.list'
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: 'list',
        component: ParticipantListComponent,
        canActivate: [PermissionService],
        data: {
          only: ROLE.ADMIN,
          redirectTo: ''
        }
      },
      {
        path: 'import/:excelId',
        component: UserImportComponent,
        canActivate: [PermissionService],
        data: {
          only: ROLE.ADMIN,
          redirectTo: ''
        }
      },
      {
        path: 'create',
        component: UserFormComponent,
        canActivate: [PermissionService],
        data: {
          breadcrumb: 'participant.create',
          only: ROLE.ADMIN,
          redirectTo: ''
        }
      },
      {
        path: ':userId/edit',
        component: UserFormComponent,
        canActivate: [PermissionService],
        data: {
          breadcrumb: 'participant.edit',
          only: ROLE.ADMIN,
          redirectTo: ''
        },
        resolve: {
          user: UserResolve
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ParticipantRoutingModule { }



// WEBPACK FOOTER //
// /dist/src/app/user/participant/participant-routing.module.ts